<main>
    <div class="alert valign-children-middle" *ngIf="error">
        <div class="alert-error" role="img" aria-label="Error">
          <i class="icon-badgealert"></i>
        </div>
        <div>
          <span>{{errorMessage}}</span>
        </div>
      </div>
<section  aria-labelledby="ProfilePageNameSection" *ngIf="fans && pageDetails">
    <div class="fan-wrapper">
        <h1 id="ProfilePageNameSection" >{{pageDetails.heading1}}<span class="mobile-title" style="line-height:normal">{{fans.profileName}}</span></h1>
    <section  aria-labelledby="mdmServiceHeadingSection1" *ngIf = "!oemStatus">
      <h2 id="mdmServiceHeadingSection1" >{{pageDetails.mdmServiceHeading}}</h2>
      <div>
        <p [innerHTML]="pageDetails.mdmService + fans.mdmServiceName"></p>
      </div>

      <h2 class="pageDetails-heading2">{{pageDetails.heading2}}</h2>
      <div>
        <p>{{pageDetails.newDevices}}<span>{{fans.newDevices}}</span></p>
        <p>{{pageDetails.existingDevices}}<span>{{fans.existingDevices}}</span></p>
        <p>{{pageDetails.security}} <span>{{settingsConfig.securityPolicy[fans.security]}}</span></p>
        <p>{{pageDetails.passcode}} <span>{{settingsConfig.passcodePolicy[fans.passcode]}}</span></p>
        <p>{{pageDetails.notification}} <span>{{fans.notifications}}</span></p>
        <p>{{pageDetails.enrollment}} <span>{{fans.enrollment}}</span></p>
        <p>{{pageDetails.newDeviceDate}} <span>{{(!fans?.fanList[0]?.newDeviceEffectiveDate)?pageDetails.noDateSetLabel:fans.fanList[0].newDeviceEffectiveDate}}</span></p>
        <p>{{pageDetails.existDeviceDate}} <span>{{(!fans?.fanList[0]?.existDeviceEffectiveDate)?pageDetails.noDateSetLabel:fans.fanList[0].existDeviceEffectiveDate}}</span></p>
      </div>
      <h2>{{pageDetails.subHeading}}</h2>
      <ul>
        <li class="app-list" *ngFor="let app of fans.applications">
          {{app}}
        </li>
      </ul>
    </section>

    <section aria-labelledby="mdmServiceHeadingSection2" *ngIf = "oemStatus">
        <h2 id="mdmServiceHeadingSection2" >{{pageDetails.mdmServiceHeading}}</h2>
        <div>
          <p>{{pageDetails.mdmService}}<span> {{fans.mdmServiceName}}</span></p>
          <p *ngIf="emmProductCode === 'DMPSKME'">{{pageDetails.oemDetailsKme}} <span>{{emmAccountId}}</span></p>
          <p *ngIf="emmProductCode === 'DMPGZTP'">{{pageDetails.oemDetailsZtp}} <span>{{emmAccountId}}</span></p>
        </div>

        <h2>{{pageDetails.heading2}}</h2>
        <div>
          <p><span>{{pageDetails.notification}} {{fans.notifications}}</span></p>
          <p>{{pageDetails.newDeviceDate}} <span>{{(!fans?.fanList[0]?.newDeviceEffectiveDate)?pageDetails.noDateSetLabel:fans.fanList[0].newDeviceEffectiveDate}}</span></p>
          <p>{{pageDetails.existDeviceDate}} <span>{{(!fans?.fanList[0]?.existDeviceEffectiveDate)?pageDetails.noDateSetLabel:fans.fanList[0].existDeviceEffectiveDate}}</span></p>
        </div>
    </section>

    <section aria-label="Foundation Accounts list" class="fan-section">
      <div *ngIf="fanList.length <= 5">
        <app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
      </div>
      <div *ngIf="fanList.length > 5">
        <app-accordion [accordion]="accordionList" [accordionController]=false>
          <app-accordion-list *ngFor="let acc of accordionList; let i = index" [option]='acc' [isSubAccordion]=true>
            <app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
          </app-accordion-list>
        </app-accordion>
      </div>
    </section>
    <div class="accordion-section" *ngIf="!oemStatus && supportArticle">
      <app-accordion [accordion]="supportArticles" [accordionController]=false>
          <app-accordion-list *ngFor="let option of supportArticles; let i=index " [option]='option' [isSubAccordion]=true>
            <div class="support-content mediaStop" id="player" *ngFor="let article of this.article.availableArticle; let i=index">
              <!-- <a href="javascript:void(0)"  (click)="getSupportContent(i)" >{{article.name}}</a> -->
              <att-gvp *ngIf="article.url" [attr.video]="article.url" ></att-gvp>
            </div>
        </app-accordion-list>
      </app-accordion>
    </div>
  </div>
  <div *ngIf="showOverviewModal">
    <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
      <div class="model-cover terms">
        <div class="model-box">
          <div class="modal-header">
            <div class="corner-button">
              <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
            </div>
            <att-gvp [attr.video]="videoId"></att-gvp>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</section>

<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
</main>